module.exports = __webpack_public_path__ + "images/0d07b3a8be65917693cacee10db93099-attention_icon.png";